import { schwoomp } from './sound.ts';

/**
 * Dealing (FR-FX-01): cards that arrive in your hand slide in one after another with a card sound,
 * and cards that appear elsewhere on the table (a play, a discard) make the sound. Runs after each
 * render by comparing card ids with the last render. Joining, reconnecting or switching seats in
 * pass & play shows the hand as it is, without dealing it again.
 */
let scope = '';
let lastSeq = -1;
let seen = new Set<string>();
let quiet = true;
/** Set while this player waits in the lobby, so the game that starts next is dealt, not just shown. */
let fromLobby = false;

export function inLobby(): void {
  fromLobby = true;
  scope = '';
}

/** Called by the table view each render: which game, which seat, and the move counter. */
export function noteTable(gameId: string, seat: number | null, seq: number): void {
  const key = `${gameId}:${seat}`;
  if (key !== scope) {
    scope = key;
    seen = new Set();
    quiet = !fromLobby;
    fromLobby = false;
  } else if (seq < lastSeq) {
    // A new game at the same table: deal it.
    seen = new Set();
    quiet = false;
  }
  lastSeq = seq;
}

/** Leaving the table: the next one starts quiet. */
export function resetFx(): void {
  scope = '';
  seen = new Set();
  quiet = true;
}

const MAX_DEALT = 13;
const STAGGER_MS = 70;

export function afterRender(root: HTMLElement): void {
  if (!scope) return;
  const cards = [...root.querySelectorAll<HTMLElement>('[data-card]')];
  const fresh = cards.filter((c) => !seen.has(c.dataset['card'] ?? ''));
  for (const c of cards) seen.add(c.dataset['card'] ?? '');
  if (quiet) {
    quiet = false;
    return;
  }
  if (!fresh.length) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let n = 0;
  for (const c of fresh) {
    if (!c.closest('[data-testid=hand]') || n >= MAX_DEALT) continue;
    if (!reduced) {
      c.classList.add('dealt');
      c.style.animationDelay = `${n * STAGGER_MS}ms`;
    }
    n++;
  }
  // Running count of dealt cards, for tests and debugging.
  document.body.dataset['dealt'] = String(Number(document.body.dataset['dealt'] ?? 0) + n);
  const sounds = Math.min(Math.max(n, 1), 6);
  for (let i = 0; i < sounds; i++) schwoomp((i * STAGGER_MS) / 1000);
}
